import React from 'react';
import { Box, Container, Typography, IconButton, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

interface HeaderProps {
  title: string;
  subtitle?: string;
  onMenuClick?: () => void;
  onBack?: () => void;
  actions?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ title, subtitle, onMenuClick, onBack, actions }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        // position: 'fixed',
        // top: 0,
        // left: 0,
        // right: 0,
        // zIndex: 1100,
        bgcolor: 'primary.main',
        color: '#fff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            py: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {isMobile && onMenuClick && (
              <IconButton onClick={onMenuClick} sx={{ color: '#fff', p: 0.5 }}>
                <MenuIcon fontSize="small" />
              </IconButton>
            )}

            <Box>
              <Typography variant="h6" sx={{ fontSize: 15, fontWeight: 500 }}>
                {title}
              </Typography>
              {subtitle && (
                <Typography variant="caption" sx={{ opacity: 0.8, fontSize: 10 }}>
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Box>

          {actions && <Box sx={{ display: 'flex', gap: 1 }}>{actions}</Box>}
        </Box>
      </Container>
    </Box>
  );
};

export default Header;